module.exports = __webpack_public_path__ + "img/fourth.c8ef49d1.jpg";